
export default {
    code:'BES_NZ_CARBONCLICK_AVIATION_FESTIVAL_ASIA_2023',
    content:{
        transaction: {
            headerText: 'Congratulations! You\'ve made a difference. Here are the details:',
            items: []
        },
    }
}